import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AddPodcast from 'features/AddPodcast';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from '@material-ui/core';
import Table from '@material-ui/core/Table';
import Skeleton from 'components/Skeleton';
import usePodcastList from 'customHooks/usePodcastList';
import Pagination from '@material-ui/lab/Pagination';
import images from 'images/images.jfif';
import { MdModeEdit, MdDelete } from 'react-icons/md';
import { FaSpotify } from 'react-icons/fa';
import { AiFillApple } from 'react-icons/ai';
import { showPopup } from 'components/ConfirmPopup/popupSlice';
import Popup from 'components/ConfirmPopup';
import { imgBaseURL } from '../../apis/Admin';
import { IoIosArrowBack } from 'react-icons/io';
import { showLoader } from 'utils';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 1000,
  },
  container: {
    margin: '1rem',
  },
  filter: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '1rem',
  },
  pagination: {
    marginLeft: 'auto',
    margincenter: 'auto',
    marginBottom: '60px',
  },
  center: {
    textAlign: 'center',
  },
  start: {
    textAlign: 'start',
  },
  end: {
    textAlign: 'end',
  },
  imgWidth: {
    width: '50px',
  },
  pointer: {
    cursor: 'pointer',
  },
  green: {
    cursor: 'pointer',
    color: 'green',
  },
  gray: {
    cursor: 'pointer',
    color: 'gray',
  },
  backBtn: {
    fontFamily: 'sans-serif !important',
    background: '#c6c6c6',
    transition: 'background 0.3s ease',
    '&:hover': {
      color: 'white',
      background: '#858685',
    },
  },
  btn: {
    fontFamily: 'sans-serif !important',
    background: '#45b77c',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: '#358c5e',
    },
  },
});

export default function News() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [currentId, setCurrentId] = useState('');
  const [editData, setEditData] = useState('');
  const [showAddPodcast, setShowAddPodcast] = useState(false);
  const [showPodcast, setShowPodcast] = useState(true);
  const [showPodcastBtn, setShowPodcastBtn] = useState(false);
  const [showPodcastAddBtn, setShowPodcastAddBtn] = useState(true);
  const [showEditBtn, setShowEditImg] = useState(true);
  const [callStart, setCallStart] = useState(0);
  const [page, setPage] = React.useState(1);
  const totalUsers = useSelector(state => state.podcast.totalList);
  const loading = useSelector(state => state.podcast.loading);
  const podcastList = usePodcastList(callStart, 10);
  const imgUrl = imgBaseURL;
  const popupDisplay = useSelector(state => state.popup.visibility);
  const totalPages_pre = totalUsers / 10;
  const totalUserPages =
    totalUsers % 10 === 0 ? totalPages_pre : Math.trunc(totalPages_pre) + 1;
  console.log(podcastList, 'podcastList');

  useEffect(() => {
    setCallStart((page - 1) * 10);
  }, [page]);

  const handlePageChange = value => {
    setPage(value);
  };

  const pageFunc = () => {
    if (totalUserPages) {
      return totalUserPages;
    }
    return 0;
  };

  const addPodcast = () => {
    setShowAddPodcast(true);
    setShowPodcast(false);
    setShowPodcastBtn(true);
    setShowPodcastAddBtn(false);
    setShowEditImg(false);
  };

  const podcast = () => {
    setShowAddPodcast(false);
    setShowPodcast(true);
    setShowPodcastBtn(false);
    setShowPodcastAddBtn(true);
    setCurrentId('');
  };

  const handleEdit = id => {
    setCurrentId(id);
    const currentData = podcastList.find(podcastData => podcastData._id === id);
    setEditData(currentData);
    addPodcast();
    setShowEditImg(true);
  };
  console.log(editData, 'editData podcast');
  const handleDelete = id => {
    dispatch(showPopup({ visibility: true, id }));
  };
  const loginType = localStorage.getItem('loginType');

  const getBackBtn = val => {
    if (val) {
      return (
        <Grid item xs={12}>
          <Button variant="contained" className={classes.backBtn} onClick={podcast}>
            <IoIosArrowBack size={20} /> <span>Back</span>
          </Button>
        </Grid>
      );
    }
  };

  return (
    <Skeleton>
      <div className={classes.root}>
        <Grid container spacing={3}>
          {getBackBtn(showPodcastBtn)}
          {showPodcastAddBtn ? (
            <Grid item xs={12} className={classes.end}>
              <Button variant="contained" color="primary" className={classes.btn} onClick={addPodcast}>
                Add Podcast
              </Button>
            </Grid>
          ) : (
            ''
          )}
          {showPodcast ? (
            <>
              <Grid item xs={12}>
                <TableContainer className={classes.container} component={Paper}>
                  <Table className={classes.table} aria-label="simple table">
                    <TableHead className={classes.tabelHeaderBackground}>
                      <TableRow>
                        <TableCell
                          align="center"
                          className={classes.tabelHeaderColor}
                        >
                          Image
                        </TableCell>
                        <TableCell
                          align="center"
                          className={classes.tabelHeaderColor}
                        >
                          Title
                        </TableCell>
                        <TableCell
                          align="center"
                          className={classes.tabelHeaderColor}
                        >
                          Description
                        </TableCell>
                        <TableCell
                          align="center"
                          className={classes.tabelHeaderColor}
                        >
                          Spotify
                        </TableCell>
                        <TableCell
                          align="center"
                          className={classes.tabelHeaderColor}
                        >
                          Apple music
                        </TableCell>
                        {parseInt(loginType) === 1 && (
                          <TableCell
                            align="center"
                            className={classes.tabelHeaderColor}
                          >
                            User
                          </TableCell>
                        )}
                        <TableCell
                          align="center"
                          className={classes.tabelHeaderColor}
                        >
                          Status
                        </TableCell>
                        <TableCell
                          align="center"
                          className={classes.tabelHeaderColor}
                        >
                          Edit
                        </TableCell>
                        <TableCell
                          align="center"
                          className={classes.tabelHeaderColor}
                        >
                          Delete
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {podcastList.map(podcastInfo => (
                        <TableRow
                          key={podcastInfo._id}
                          className={classes.center}
                        >
                          <TableCell align="center">
                            <img
                              src={
                                podcastInfo.image
                                  ? `${imgUrl}/${podcastInfo.image}`
                                  : images
                              }
                              alt="podcast_image"
                              className={classes.imgWidth}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {podcastInfo.title}
                          </TableCell>
                          <TableCell align="center">
                            {podcastInfo.description}
                          </TableCell>
                          <TableCell align="center">
                            <FaSpotify
                              size={25}
                              className={classes.green}
                              onClick={() =>
                                window.open(podcastInfo.spotifyLink)
                              }
                            />
                          </TableCell>
                          <TableCell align="center">
                            <AiFillApple
                              size={25}
                              className={classes.gray}
                              onClick={() =>
                                window.open(podcastInfo.appleMusicLink)
                              }
                            />
                          </TableCell>
                          {parseInt(loginType) === 1 && (
                            <TableCell align="center">
                              {podcastInfo.user?.userName}
                            </TableCell>
                          )}
                          <TableCell align="center">
                            {podcastInfo.verifyStatus}
                          </TableCell>
                          <TableCell align="center">
                            <MdModeEdit
                              size={25}
                              className={classes.pointer}
                              onClick={() => handleEdit(podcastInfo._id)}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <MdDelete
                              size={25}
                              className={classes.pointer}
                              onClick={() => handleDelete(podcastInfo._id)}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <div style={{ textAlign: 'center' }}>
                    {podcastList.length === 0 && 'No Data'}
                  </div>
                </TableContainer>
                <div className={classes.pagination}>
                  <Pagination
                    color="primary"
                    count={pageFunc()}
                    page={page}
                    onChange={handlePageChange}
                  />
                </div>
              </Grid>
            </>
          ) : (
            ''
          )}
          {showAddPodcast ? (
            <Grid item xs={12}>
              <AddPodcast
                currentId={currentId}
                editData={editData}
                showEditBtn={showEditBtn}
                setShowEditImg={setShowEditImg}
              />
            </Grid>
          ) : (
            ''
          )}
        </Grid>
      </div>
      {showLoader(loading)}
      {popupDisplay ? <Popup parent="podcast" /> : false}
    </Skeleton>
  );
}
